import { useState, useEffect } from 'react'
import Hero from './components/Hero'
import { PhoneMockup } from './components/Phone'
import Splash from './components/Splash'
import Footer from './components/Footer'
import ErrorBoundary from './components/ErrorBoundary'
import { Analytics } from '@vercel/analytics/react'
import { debounce } from './utils/debounce'

function App() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768)
    const debouncedCheckMobile = debounce(checkMobile, 150)
    window.addEventListener('resize', debouncedCheckMobile)
    return () => window.removeEventListener('resize', debouncedCheckMobile)
  }, [])

  // Mobile view: Show app interface directly
  if (isMobile) {
    return (
      <>
        <ErrorBoundary>
          <Splash />
        </ErrorBoundary>
        <Analytics />
      </>
    )
  }

  // Desktop view: Show landing page with phone mockup
  return (
    <div className="min-h-screen bg-[#efece4]">
      <ErrorBoundary>
        <main className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
          <Hero />
          <PhoneMockup />
        </main>
      </ErrorBoundary>
      
      <Footer />
      <Analytics />
    </div>
  )
}

export default App